class MFRFadingList {
    constructor( i, e ) {
        this.$index = i;
        this.$element = $( e );

        this.selectors = {
            item: "> *"
        }

        this.currentIndex = 0;
        this.animationDuration = 800;

        this.init();
    }

    init() {
        this.$item = this.$element.find( this.selectors.item );
        this.$item.css("transition", `all ${ this.animationDuration / 1000 }s linear`);
        this.initFadingList();
    }

    initFadingList() {
        const initialElement = this.$element
            .find( `${ this.selectors.item }[data-index="${this.currentIndex}"]`)
            .addClass( "is-active" );
        this.animateFading();

        this.interval = setInterval(() => {
          this.$item.removeClass("is-active");
          this.$element
            .find(`${this.selectors.item}[data-index="${this.currentIndex}"]`)
            .addClass("is-active");

          this.animateFading();

          if (this.currentIndex == this.$item.length - 1) {
            this.currentIndex = 0;
            return;
          }

          this.currentIndex++;
        }, this.animationDuration );
    }

    animateFading() {
        const opacitySettings = [
            1, 0.7, 0.3, 0.2, 0.1
        ]
        for (let index = 1; index <= 4; index++) {
            const activeIndex = this.$element.find(
              `${this.selectors.item}.is-active`
            ).data( "index" );
            const beforeElement = this.$element.find(
              `${this.selectors.item}[data-index="${activeIndex - index}"]`
            );
            const afterElement = this.$element.find(
              `${this.selectors.item}[data-index="${activeIndex + index}"]`
            );

            this.$element.find(`${this.selectors.item}.is-active`).css( "opacity", "" );
            beforeElement.css( "opacity", opacitySettings[index] ?? 0 );
            afterElement.css( "opacity", opacitySettings[index] ?? 0 );
        }
    }
}